import { ApolloError } from '@apollo/client';

import { useFakturowniaInvoiceQuery } from 'core/graphql';

import { IFakturowniaInvoiceDetail } from './types';
import { isPermissionDeniedError } from './errors';

interface IFakturowniaInvoiceHook {
  invoice?: IFakturowniaInvoiceDetail;
  loading: boolean;
  error?: ApolloError;
  permissionDenied: boolean;
  refetch: () => void;
}

/** Loads one invoice for the detail screen (TZ §3.3). */
export const useFakturowniaInvoice = (id?: string): IFakturowniaInvoiceHook => {
  const { data, loading, error, refetch } = useFakturowniaInvoiceQuery({
    variables: { id: id || '' },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    invoice: data?.fakturowniaInvoice ?? undefined,
    loading,
    error,
    permissionDenied: isPermissionDeniedError(error),
    refetch: () => {
      refetch();
    },
  };
};
